import { NavLink } from 'react-router-dom';

export default function NavBar() {
  return (
    <div className="nav">
      <div className="nav-brand">
        FLOWGUARD
      </div>
      <div className="nav-links">
        <NavLink to="/" end className="nav-link">Dashboard</NavLink>
        <NavLink to="/logs" className="nav-link">Logs</NavLink>
      </div>
    </div>
  );
}
